import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  colorLandingBrandSoft,
  colorLandingBrandStrong,
  colorLandingInk,
  colorLandingSurface,
} from "src/design/tokens";

// Illustrative staff initials for the team tab.
const MEMBERS = ["HZ", "RZ", "SB", "YM"];

/** Stacked staff avatars above the role chips, for the team tab. */
export const TeamMedia = () => {
  const { t } = useTranslation();

  const roles = [
    "landingPage.showcase.team.roles.manager",
    "landingPage.showcase.team.roles.receptionist",
    "landingPage.showcase.team.roles.waiter",
    "landingPage.showcase.team.roles.venues",
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.75, width: "100%" }}>
      <Box sx={{ display: "flex", alignItems: "center", pl: 0.75 }}>
        {MEMBERS.map((member) => (
          <Box
            key={member}
            sx={{
              ml: "-6px",
              width: 34,
              height: 34,
              borderRadius: "50%",
              border: `2px solid ${colorLandingSurface}`,
              backgroundColor: colorLandingBrandSoft,
              color: colorLandingBrandStrong,
              display: "grid",
              placeItems: "center",
              fontWeight: 700,
              fontSize: 12,
            }}
          >
            {member}
          </Box>
        ))}
        <Box
          sx={{
            ml: "-6px",
            width: 34,
            height: 34,
            borderRadius: "50%",
            border: `2px solid ${colorLandingSurface}`,
            backgroundColor: colorLandingInk,
            color: colorLandingSurface,
            display: "grid",
            placeItems: "center",
            fontWeight: 700,
            fontSize: 11,
          }}
        >
          +3
        </Box>
      </Box>

      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
        {roles.map((role) => (
          <Typography
            key={role}
            sx={{
              fontSize: 11,
              fontWeight: 700,
              px: 1.375,
              py: 0.625,
              borderRadius: 999,
              backgroundColor: colorLandingBrandSoft,
              color: colorLandingBrandStrong,
            }}
          >
            {t(role)}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};
